// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

class CommentAPI extends MainAPI {
	/** 
	 * @param {*} commentDetails
	 */
	async saveComment(commentDetails) {
		const formData = new FormData();
		const { image, formDetails } = commentDetails;

		formData.append(
			'formData',
			JSON.stringify(formDetails)
		);

		if (image) {
			formData.append(
				'image',
				image
			);
		}

		return API.post(ENDPOINTS.POST_COMMENT, formData, { timeout: 180000 });
	}

	async getCommentById(commentId) {
		return API.get(`${ENDPOINTS.GET_COMMENTS}/${commentId}`);
	}

	async getComments(options) {
		return API.get(ENDPOINTS.GET_COMMENTS, options);
	}

	async updateComment(commentDetails) {
		const formData = new FormData();
		const { image, formDetails } = commentDetails;

		formData.append(
			'formData',
			JSON.stringify(formDetails)
		);

		if (image) {
			formData.append(
				'image',
				image
			);
		}

		return API.patch(ENDPOINTS.PATCH_COMMENT, formData, { timeout: 180000 });
	}

	async deleteComment(commentId) {
		return API.delete(`${ENDPOINTS.DELETE_COMMENT}/${commentId}`);
	}
}

export default new CommentAPI();
